import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { fetchViews, getViews, getLoading } from '../../../ducks/views'
import { getCurrentOrganizationId, getCurrentUser } from '../../../ducks/users'
import { FullScreenLoader } from '../../Shared/Loading'
import EmptyState from '../../Shared/EmptyState'
import Button from '../../Shared/Button'

export default function Viewer() {
  const dispatch = useDispatch()
  const organizationId = useSelector(getCurrentOrganizationId)
  const views = useSelector(getViews(organizationId))
  const user = useSelector(getCurrentUser)
  const lastView = views.filter(id => id === user.lastViewId)[0]
  const loading = useSelector(getLoading)

  useEffect(() => {
    dispatch(fetchViews(organizationId))
  }, [dispatch, organizationId])

  if (loading) {
    return <FullScreenLoader />
  }

  if (views.length === 0) {
    return (
      <EmptyState>
        <h2>No Views Yet</h2>
        <Button to="/databases/create-view" icon="add">
          Create View
        </Button>
      </EmptyState>
    )
  }

  const view = lastView || views[0]

  return <Redirect to={`/databases/views/${view.id}`} />
}
